import { css } from 'lit';
export const tabGroupStyles = css `
    .hlx-tab-group-header {
        display: flex;
        flex-direction: row;
        position: relative;
        overflow: hidden;
        user-select: none;
        box-shadow: inset 0 -1px 0 var(--hlx-border-color-weak-1);
        padding-bottom: 1px;
    }

    .hlx-tab-group-nav {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 32px;
        padding: 0;
        border: 1px solid var(--hlx-border-color-weak-1);
        z-index: 3;
        background: var(--hlx-background-color-default);
        box-shadow: var(--hlx-drop-shadow-10);
        cursor: pointer;
        color: var(--hlx-text-link-color-default);
        transition-duration: var(--hlx-motion-duration-default);
        transition-timing-function: var(--hlx-motion-easing-in-out);
        transition-property: color, background-color;
        -webkit-tap-highlight-color: transparent;
    }

    .hlx-tab-group-nav.hlx-swiper-initialized {
        display: block;
    }

    @media not (hover: none) {
        .hlx-tab-group-nav:hover {
            background: var(--hlx-color-brand-weak-2);
        }
    }
    .hlx-tab-group-nav:focus-visible {
        background: var(--hlx-color-brand-weak-2);
        border: 2px solid var(--hlx-color-brand-default);
        outline: none;
    }
    .hlx-tab-group-nav:disabled {
        color: var(--hlx-input-text-color-disabled);
    }
    .hlx-tab-group-nav:active {
        color: var(--hlx-text-link-color-active);
        background: var(--hlx-background-color-default);
    }

    .hlx-tab-group-nav-prev {
        left: 0;
    }
    .hlx-tab-group-nav-next {
        right: 0;
    }

    .hlx-tab-container-slot::after {
        content: '';
        display: block;
        position: absolute;
        left: var(--hlx-tab-current-offset, 0);
        bottom: 0;
        width: var(--hlx-tab-current-width, 0);
        height: 4px;
        background: var(--hlx-color-brand-strong-1);
        z-index: 1;
        transition:
            width var(--hlx-motion-easing-in-out) var(--hlx-motion-duration-default),
            left var(--hlx-motion-easing-in-out) var(--hlx-motion-duration-default),
            translate 400ms;
    }
    .hlx-tab-panel-container {
        padding-top: var(--hlx-spacing-3xl);
    }

    .swiper {
        overflow-x: hidden;
        overflow-y: visible;
        list-style: none;
        padding: 0;
        z-index: 1;
    }
    .swiper-wrapper {
        display: flex;
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1;
        transition-property: transform;
        transition-timing-function: var(--swiper-wrapper-transition-timing-function, initial);
        box-sizing: border-box;
    }
    .swiper-android .swiper-slide,
    .swiper-ios .swiper-slide,
    .swiper-wrapper {
        transform: translate3d(0px, 0, 0);
    }
    .swiper-horizontal {
        touch-action: pan-y;
    }
    .swiper-slide {
        flex-shrink: 0;
        height: 100%;
        position: relative;
        transition-property: transform;
        display: block;
    }
    .swiper-slide-invisible-blank {
        visibility: hidden;
    }

    /* Auto Height */
    .swiper-backface-hidden .swiper-slide {
        transform: translateZ(0);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    /* Navigation */
    .swiper-button-disabled {
        visibility: hidden;
    }
`;
export const tabStyles = css `
    .hlx-tab-header {
        height: 100%;
        background: none;
        font-size: var(--hlx-text-font-size-md);
        font-family: var(--hlx-text-font-family-sans-serif);
        font-weight: var(--hlx-text-font-weight-medium);
        line-height: var(--hlx-text-line-height-default);
        padding: var(--hlx-spacing-lg) var(--hlx-spacing-md) calc(var(--hlx-spacing-lg) + 4px);
        border-width: 2px 2px 0 2px;
        border-style: solid;
        border-color: transparent;
        box-sizing: border-box;
        cursor: pointer;
        color: var(--hlx-text-color-weak-2);
        white-space: nowrap;
        scroll-snap-align: start;
        user-select: none;
        transition-duration: var(--hlx-motion-duration-default);
        transition-timing-function: var(--hlx-motion-easing-in-out);
        transition-property: color, background-color;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--hlx-spacing-xs);
        -webkit-tap-highlight-color: transparent;
    }

    @media not (hover: none) {
        .hlx-tab-header:hover {
            color: var(--hlx-text-link-color-default);
            background: var(--hlx-color-brand-weak-2);
        }
    }

    .hlx-tab-header:focus-visible {
        outline: none;
        border-top-color: var(--hlx-color-brand-default);
        border-right-color: var(--hlx-color-brand-default);
        border-left-color: var(--hlx-color-brand-default);
    }
    .hlx-tab-header:disabled {
        cursor: not-allowed;
        background: none;
        color: var(--hlx-text-color-weak-2);
    }

    .hlx-tab-header-selected {
        color: var(--hlx-text-link-color-active);
    }
`;
export const tabCaptionStyles = css `
    .hlx-tab-label {
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    .hlx-tab-label-bottom {
        font-weight: var(--hlx-text-font-weight-semibold);
    }
`;
//# sourceMappingURL=tab-group.styles.js.map